import { Link } from 'react-scroll';
import { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';

// Helper function to capitalize the first letter of each word
const capitalize = (text) => {
  return text
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="fixed top-0 left-0 w-full bg-white shadow-md z-50">
      {/* Header Design with Logo and Curves */}
      <div className="relative h-[70px] sm:h-[50px] md:h-[80px] lg:h-[110px] overflow-hidden">

        {/* UDC Logo */}
        <div className="absolute top-3 sm:top-4 md:top-5 left-4 sm:left-5 mt-2">
          <Link to="home" smooth={true} duration={500} className="cursor-pointer">
            <img
              src="/assets/imgs/logo3.png"
              alt="UDC Logo"
              className="h-8 sm:h-6 md:h-8 lg:h-12 xl:h-16 w-auto lg:pl-10"
            />
          </Link>
        </div>

        {/* Hamburger Menu for Mobile */}
        <div className="absolute top-4 right-4 md:hidden">
          <button onClick={toggleSidebar}>
            {isOpen ? <FaTimes className="text-3xl text-gray-600" /> : <FaBars className="text-3xl text-gray-600" />}
          </button>
        </div>
      </div>

      {/* Navigation Links for Desktop */}
      <div className="hidden md:flex absolute top-[5px] md:top-[25px] lg:top-[30px] right-5 text-right px-6">
        <div className="container mx-auto px-4 py-2 md:px-6 md:py-4 flex justify-center items-center">
          <ul className="flex flex-wrap space-x-4 md:space-x-6 lg:space-x-12 text-gray-600 font-playfair text-sm md:text-base">
            {['home', 'about-us', 'products', 'applications', 'FAQs', 'contact-us'].map((section) => (
              <li key={section}>
                <Link
                  to={section}
                  smooth={true}
                  duration={500}
                  spy={true}
                  activeClass="active"
                  className="hover:text-[#2E5970] cursor-pointer font-normal hover:italic"
                >
                  {capitalize(section)}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Sidebar Navigation for Mobile */}
      <div
        className={`fixed top-0 right-0 w-[180px] bg-white h-full z-40 transform ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        } transition-transform duration-300 ease-in-out shadow-lg`}
      >
        <ul className="flex flex-col space-y-6 mt-24 ml-5 text-gray-600 font-playfair text-lg">
          {['home', 'about-us', 'products', 'applications', 'FAQs', 'contact-us'].map((section) => (
            <li key={section}>
              <Link
                to={section}
                smooth={true}
                duration={500}
                spy={true}
                activeClass="active"
                className="hover:text-[#2E5970] cursor-pointer font-normal hover:italic"
                onClick={toggleSidebar}
              >
                {capitalize(section)}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
